import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=f1056fbe&scoped=true"
import script from "./Recipes.vue?vue&type=script&lang=js"
export * from "./Recipes.vue?vue&type=script&lang=js"
import style0 from "./Recipes.vue?vue&type=style&index=0&id=f1056fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1056fbe",
  null
  
)

export default component.exports